import { Block, Flex, Icon, IconButton, Typography } from '@aloft/toolkit-sui';

import { dismissAllToasts } from '../../hooks/useToaster/dismissAllToasts.ts';
import { selectIsInspectifyOrder } from '../../redux/features/selectors/orderSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { useModuleContext } from '../../modules/shared/moduleContext/useModuleContext.ts';

export const MainHeaderTitle = ({
  title,
  shouldShowHeaderNavigation,
  showBackButton,
  onBackButtonClick,
}: {
  title: string;
  shouldShowHeaderNavigation: boolean;
  showBackButton: boolean;
  onBackButtonClick?: () => void;
}) => {
  const isInspectifyOrder = useAppSelector(selectIsInspectifyOrder);
  const {
    navigation: { NavLink, useNavigate },
  } = useModuleContext();

  const navigate = useNavigate();
  const shouldUseLegacy = !isInspectifyOrder;

  if (shouldShowHeaderNavigation && !shouldUseLegacy) {
    return (
      <div className="main-header-title-with-nav" title={title}>
        <Flex className="main-header-title-breadcrumb" alignItems="center">
          <NavLink
            to="/orders"
            className="main-header-title-breadcrumb-orders-link"
            onClick={dismissAllToasts}
          >
            <Typography variant="h2" __dangerDoNotUseSx={{ fontWeight: 400 }}>
              My Orders
            </Typography>
          </NavLink>
          <Icon icon="arrow-right-s" size="md" color="textTertiary" />
          <Typography variant="h2" title={title} truncate>
            {title}
          </Typography>
        </Flex>
      </div>
    );
  }

  if (shouldShowHeaderNavigation) {
    return null;
  }

  return (
    <Flex flexGrow={1} gap={1} alignItems="center">
      {showBackButton && (
        <Block flexShrink={1}>
          <IconButton
            id="back-btn"
            ariaLabel="back"
            icon="arrow-left"
            onClick={() => {
              if (onBackButtonClick) {
                onBackButtonClick();
              } else {
                navigate(-1);
              }
            }}
            variant="tertiary"
            size="md"
            __dangerDoNotUseSx={{
              svg: { height: '22px', width: '22px' },
            }}
          />
        </Block>
      )}
      <Typography variant="h2">{title}</Typography>
    </Flex>
  );
};
